import type { ComponentType } from '@grafikr/components';

import { NonNullish } from 'utils/nullish-check';

const Component: ComponentType = (node) => {
  const section = NonNullish(node.closest('.shopify-section'));
  const backButtons = NonNullish(section.querySelectorAll<HTMLElement>('[data-back]'));
  const firstLayers = NonNullish(section.querySelectorAll<HTMLElement>('[data-first-layer]'));

  const lists = Array.from(section.querySelectorAll<HTMLElement>('[data-list]'));
  const mainList = NonNullish(lists.at(0));

  const handleActionVisibility = () => {
    const isMain = !lists.some((list) => list !== mainList && !list.hidden);

    firstLayers.forEach((firstLayer) => {
      firstLayer.hidden = !isMain;
    });
  };

  const setChevron = (list: HTMLElement, open: boolean) => {
    const link = section.querySelector<HTMLElement>(`[aria-controls="${list.id}"]`) ?? list.previousElementSibling;
    link?.querySelector<HTMLElement>('[data-chevron]')?.classList.toggle('rotate-180', open);
  };

  const openList = (list: HTMLElement) => {
    lists.forEach((item) => {
      if (item === list) {
        item.hidden = false;
        setChevron(item, true);
      } else {
        item.hidden = !item.contains(list);
        if (item.hidden) setChevron(item, false);
      }
    });

    handleActionVisibility();
  };

  const closeList = (list: HTMLElement) => {
    list.hidden = true;
    setChevron(list, false);
    handleActionVisibility();
  };

  const toggleList = (list: HTMLElement) => {
    if (list.hidden) {
      openList(list);
    } else {
      closeList(list);
    }
  };

  const links = section.querySelectorAll<HTMLElement>('[aria-haspopup], [aria-controls]');

  backButtons.forEach((backButton) => {
    backButton.addEventListener('click', () => {
      openList(mainList);
    });
  });

  links.forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();

      let subList: HTMLElement | undefined;
      if (link.hasAttribute('aria-controls')) {
        subList = NonNullish(
          section.querySelector<HTMLUListElement>(`#${link.getAttribute('aria-controls')}`),
        );
      } else {
        subList = NonNullish(link.parentElement?.querySelector('[data-list]'));
      }

      toggleList(subList);
    });
  });
};

export default Component;
